import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useNavigate, useOutletContext } from "react-router-dom";
import { KeyboardBackspaceRounded } from "@mui/icons-material";
import BasicDetails from "./DashboardComponents/BasicDetails/BasicDetails";
import { mboStoreDrawerElements } from "./data";

const MboSelectedStoreDashboard = () => {
	const [tab, setTab] = useOutletContext();
	const navigate = useNavigate();
	const tabComponents = [
		{
			...mboStoreDrawerElements.store_details,
			component: <BasicDetails />,
		},
	];
	return (
		<Box sx={{ width: "100%" }}>
			<Button
				startIcon={<KeyboardBackspaceRounded />}
				variant="outlined"
				onClick={() => navigate("/explore/mbo_lfs_stores/stores")}
				sx={{ m: 2 }}>
				Back
			</Button>
			{tabComponents &&
				tabComponents.map((row) => (
					<Box width="95%" margin="auto" key={row.key} display={row.key === tab ? "block" : "none"}>
						{tab === row.key && row.component}
					</Box>
				))}
		</Box>
	);
};

export default MboSelectedStoreDashboard;
